<template functional>
  <footer class="footer con" id="footer">
    <p class="tac fsS footer-link">
      <router-link to="/about/" class="plnlink">運営会社</router-link> <router-link to="/privacy/" class="plnlink">プライバシーポリシー</router-link>
    </p>
    <p class="fsS tac">Copyright(C) sports style. All Rights Reserved.</p>
  </footer>
</template>

<script>
export default {
}
</script>

<style scoped>
.footer-link a{display: inline-block; padding: 4px;}
</style>
